module.exports = __webpack_public_path__ + "assets/facebook-2740b7.svg";